import Seo from "@/components/Seo";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { Section, Eyebrow } from "@/components/Bits";
import AppCard from "@/components/AppCard";
import { APPS } from "@/data/site";

export default function Apps() {
  return (
    <>
      <Seo title="Apps & Tools | FreeRange.Education" description="Practical digital tools designed specifically for home-educating families — including a Spelling App and a Lesson Planner, both in development." />

      <Section className="pb-16 pt-32 md:pt-40">
        <Reveal>
          <Eyebrow>Apps & Tools</Eyebrow>
          <h1 className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight text-charcoal sm:text-6xl lg:text-7xl">
            Apps & Tools
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-charcoal/75">
            Practical digital tools designed specifically for home-educating families.
          </p>
        </Reveal>
      </Section>

      <Section className="pb-24 md:pb-32">
        <Stagger className="grid gap-6 lg:grid-cols-2">
          {APPS.map((app) => (
            <StaggerItem key={app.slug}>
              <AppCard app={app} />
            </StaggerItem>
          ))}
        </Stagger>
        <Reveal className="mt-10">
          <p className="max-w-2xl text-charcoal/60">
            More tools will join this page over time. Each app is being built around genuine home-education needs —
            we'll announce availability and download links here when they're ready.
          </p>
        </Reveal>
      </Section>
    </>
  );
}
